import { COLORS } from 'helpers/globals'

const errorMessage = {
  position: 'absolute',
  background: 'red',
  width: '100%',
  color: 'white',
  zIndex: 10,
  top: 0,
  left: 0,
  textAlign: 'center',
  lineHeight: '3.6rem',
  fontSize: '1.8rem',
  transition: 'height 200ms ease-in-out'
}

export default {
  SideBar: {
    minWidth: props => props.showSideBar ? 435 : 0,
    width: props => props.showSideBar ? 435 : 0,
    height: '100vh',
    position: 'relative',
    transition: 'all 150ms ease-in-out'
  },
  errorMessageHide: {
    ...errorMessage,
    height: 0
  },
  errorMessageShow: {
    ...errorMessage,
    fontSize: '1.4rem'
  },
  toggleButtonContainer: {
    position: 'absolute',
    right: '100%',
    top: '47.5%',
    backgroundColor: 'none',
    padding: '5px 0px 8px 5px',
    zIndex: 10,
    cursor: 'pointer'
  },
  toggleButtonWrapper: {
    position: 'relative',
    float: 'left',
    backgroundColor: 'white',
    border: `1px solid ${COLORS.quaternary}`,
    borderRight: '0px',
    borderRadius: '15% 0% 0% 15%'
  },
  toggleButton: {
    float: 'right',
    marginRight: '1rem',
    fontSize: '3.5rem',
    color: '#404040',
    textAlign: 'center',
    marginLeft: props => props.showSideBar ? '0.4rem' : '0.15rem',
    marginRight: props => props.showSideBar ? '0.15rem' : '0.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/SideBar/style.js